import type { ReactNode } from 'react'
import { Card, CardBody, Flex, HStack, Heading, Icon, Text } from '@chakra-ui/react'
import { faArrowTrendUp } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export const SectionCard = ({ title, count, action, children }: {
  title: string
  count?: number
  action?: ReactNode
  children: ReactNode
}) => (
  <Card variant="outline">
    <CardBody>
      <Flex
        alignItems="center"
        justifyContent="space-between"
        gap={4}
        pb={3}
        mb={4}
        borderBottomWidth="1px"
        borderColor="gray.100"
        p={4}
      >
        <HStack spacing={2.5}>
          <Icon as={FontAwesomeIcon} icon={faArrowTrendUp} color="primary.500" />
          <Heading as="h2" fontSize="md">{title}</Heading>
          {count !== undefined && (
            <Text
              as="span"
              px={2}
              py={0.5}
              bg="gray.100"
              color="gray.500"
              borderRadius="full"
              fontSize="sm"
              fontWeight="bold"
            >
              {count}
            </Text>
          )}
        </HStack>
        {action}
      </Flex>
      {children}
    </CardBody>
  </Card>
)
